<template>
  <div>
    <b-card-body>
      <b-card class="chart-selection-container">
        <b-list-group class="chart-list">
          <b-list-group-item
            v-for="option in chartOptions"
            :key="option.type"
            button
            @click="selectChart(option)"
            class="d-flex align-items-center justify-content-between chart-list-item"
          >
            <div class="d-flex align-items-center">
              <img :src="option.icon" :alt="option.type" class="chart-icon mr-3" />
              <span>{{ option.label }}</span>
            </div>
          </b-list-group-item>
        </b-list-group>
      </b-card>
    </b-card-body>
  </div>
</template>

<script>
//import pizzaChart from '@/assets/pizza-chart.svg';
//import lineChart from '@/assets/line-chart.svg';
import barChart from '@/assets/bar-chart.svg';
import gaugeChart from '@/assets/gauge-chart.svg';

export default {
  name: "ChartSelectionModal",
  data() {
    return {
      chartOptions: [
        { type: "velocimetro", label: "Gráfico de Gauge", icon: gaugeChart },
        { type: "barras", label: "Gráfico de Barras", icon: barChart },
        //{ type: "pizza", label: "Gráfico de Pizza", icon: pizzaChart },
        //{ type: "linhas", label: "Gráfico de Linhas", icon: lineChart }
      ]
    };
  },
  methods: {
    selectChart(option) {
      this.$emit("select", option);
      this.$emit("close");
    }
  }
};
</script>

<style scoped>
.chart-selection-container {
  padding: 15px;
}

.chart-list-item {
  cursor: pointer;
}

.chart-icon {
  width: 40px;
  height: auto;
}

.modal-buttons {
  margin-top: 20px;
}

.action-btn {
  border: none;
  background: transparent;
  cursor: pointer;
}

.exit-btn {
  margin-left: 5px;
  margin-right: 14px;
}
</style>